<template>
  <login-page />
</template>

<script>
import LoginPage from "@/components/Auth/Login/index";
export default {
  components: {
    LoginPage,
  },
  mounted(){
    alert("Na here o")
  }
};
</script>

<style></style>
